import React from 'react';
import { withFormik } from 'formik';
import { compose } from 'redux';
import queryString from 'query-string';
import PropTypes from 'prop-types';

import schema from './schema';
import { resetPassword } from './request';

import ResetPasswordForm from './components/reset-password-form';
import ResetedPassword from './components/reseted-password';
import InvalidToken from './components/invalid-token';

import {
  Container,
  Logo,
  Segment,
} from './styles';

const ResetPassword = (props) => {
  const {
    errors,
    setFieldValue,
    handleSubmit,
    isSubmitting,
    setFieldTouched,
    touched,
    status,
    values,
  } = props;

  const { success, error, invalidToken } = status;

  return (
    <Container>
      <Logo src="/images/playbook-logo.png" alt="Playbook" />

      <Segment>
        {!success && !invalidToken && (
          <ResetPasswordForm
            onChange={(value, field) => setFieldValue(field, value)}
            onClick={handleSubmit}
            onFieldClick={(field) => setFieldTouched(field, true)}
            errors={errors}
            touched={touched}
            type={values.type}
            onShowPasswordClick={() => setFieldValue('type', values.type === 'password' ? 'text' : 'password')}
            submitError={error}
            newPassword={values.newPassword}
            isSubmitting={isSubmitting}
          />
        )}

        {success && !invalidToken && (
          <ResetedPassword />
        )}

        {invalidToken && (
          <InvalidToken />
        )}
      </Segment>
    </Container>
  );
};

ResetPassword.propTypes = {
  errors: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  status: PropTypes.object,
  values: PropTypes.object.isRequired,
};

ResetPassword.defaultProps = {
  status: {},
};

export default compose(
  withFormik({
    validationSchema: schema,
    enableReinitialize: true,
    mapPropsToValues: () => ({
      newPassword: '',
      confirmPassword: '',
      type: 'password',
    }),
    handleSubmit: (values, { props, setStatus }) => {
      const { token } = queryString.parse(props.location.search);
      resetPassword(token, values.newPassword)
        .then((response) => {
          if (response.code === 'record_not_found') {
            setStatus({ invalidToken: true });
            return;
          }

          setStatus({ success: true });
        })
        .catch(() => setStatus({ error: true }));
    },
  }),
)(ResetPassword);
